import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 16 16" focusable="false" aria-hidden="true"><defs><clipPath id="preview__a"><rect width={16} height={16} rx={0} /></clipPath></defs><g clipPath="url(#preview__a)"><path d="M15.43 5.74C13.74 3.45 11.26 2 8.49 2 5.72 2 3.25 3.45 1.55 5.74.8 6.75.8 8.25 1.55 9.26 3.25 11.55 5.73 13 8.49 13c2.77 0 5.24-1.45 6.94-3.74.75-1.01.75-2.51 0-3.52ZM8.5 11C6.57 11 5 9.43 5 7.5S6.57 4 8.5 4 12 5.57 12 7.5 10.43 11 8.5 11Zm0-6a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5Z" fill="#00AFC6" /></g></svg>

const Preview = React.forwardRef((props, ref) => {
  return (
    <IconBase name="preview" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Preview.displayName = 'IconPreview'

export default Preview
